module.exports = __webpack_public_path__ + "img/106.b8d4610b.jpg";